module.exports = __webpack_public_path__ + "fonts/SUIT-Bold.cf624aa1.woff2";